import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { DatePicker } from '@mui/x-date-pickers'

import { SelectString } from '../../../../core/components/SelectString'
import { StyledError } from '../../../../theme/components/StyledError'
import { useUpdateSubprocesForEntity } from '../../hooks/useUpdateSubprocesForEntity'
import type { Subproces } from '../../types/Subproces'
import {
  BODEM_PAUSE_REDENEN,
  NETCHECK_PAUSE_REDENEN,
  SCHOUW_HERPLAN_REDENEN,
} from '../../types/SubprocesRedenen'

interface Props {
  subproces: Subproces
  onClose: () => void
}

const getRedenenForType = (type: Subproces['type']) => {
  switch (type) {
    case 'schouw':
      return SCHOUW_HERPLAN_REDENEN
    case 'bodem':
      return BODEM_PAUSE_REDENEN
    case 'netcheck':
      return NETCHECK_PAUSE_REDENEN
    default:
      return []
  }
}

export const PauseSubproces = ({ subproces, onClose }: Props) => {
  const { mutate: updateSubprocesForEntity, error } =
    useUpdateSubprocesForEntity()

  const redenen = getRedenenForType(subproces.type)

  const [reden, setReden] = useState<string | null>(null)
  const [dueDate, setDueDate] = useState<Date | null>(null)

  const onSubmitClick = () => {
    const proces: Partial<Subproces & { text: string }> = {
      _id: subproces._id,
      status: 'paused',
      // @ts-expect-error button is disabled when reden is null
      text: reden,
    }

    if (dueDate) {
      proces.dueDate = dueDate.toISOString()
    }

    const body = {
      entity: subproces.entity,
      subprocesInfo: proces,
    }

    updateSubprocesForEntity(body, { onSuccess: () => onClose() })
  }

  return (
    <>
      <DialogContent>
        <StyledError error={error} />
        <Typography>Wilt u dit subproces pauzeren?</Typography>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6 }}>
            <SelectString
              value={reden}
              onChange={setReden}
              fullWidth
              options={redenen}
              label="Reden van pauzeren"
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <DatePicker
              label="Optionele datum voor hervatting"
              value={dueDate}
              onChange={setDueDate}
              displayWeekNumber
              disablePast
              slotProps={{
                field: { clearable: true },
                textField: {
                  variant: 'standard',
                  sx: { pr: 1 },
                  fullWidth: true,
                },
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose} autoFocus>
          Annuleren
        </Button>
        <Button onClick={onSubmitClick} variant={'contained'} disabled={!reden}>
          Opslaan
        </Button>
      </DialogActions>
    </>
  )
}
